module.exports = __webpack_public_path__ + "img/figure-1.08b681f9.png";